//import svg4everybody from '../vendor/svg4everybody';
// import $ from "jquery";
import { Events } from "./util/events";
import Nav from "./ui/nav";
import Slider from "ui-slider";
import fontloading from "./util/font-loading";
import scrollAnims from "./ui/scroll-anim";
import counter from "ui-counter";
import { transform } from "./util/util";

function init() {
    addEventTriggers();
    setupFontLoading();

    if (typeof svg4everybody != "undefined") {
        svg4everybody();
    }

    setupSliders();
    setupAccordions();
    Nav.init();
    addEventListeners();
    initMaps();
    setupForms();
    setupVideoOverlay();
    setupSkillsParallax();
    setupSearchbox();

    var scroll = new SmoothScroll('a[href*="#"]');

    counter();
    scrollAnims();

    animateBacklink();
    setupLinksToPdfs();
}

function addEventTriggers() {
    document.addEventListener("click", function (evt) {
        Events.trigger("click", evt);
    });
}

function addEventListeners() {
    Events.on("click", function (evt) {
        Nav.onClick(evt.vars);
    });
}

function setupFontLoading() {
    fontloading({
        subFonts: [
            {
                name: "avenir light subset",
                option: {
                    weight: 400,
                },
            },
        ],
        fullFonts: [
            {
                name: "avenir light",
                option: {
                    weight: 400,
                },
            },
        ],
    });
}

if (document.readyState != "loading") {
    init();
} else {
    document.addEventListener("DOMContentLoaded", init);
}

function setupSliders() {
    setupHeroSlider();
    setupClientSlider();
    setupCaseStudiesSlider();
    setupHeaderSlider();
}

function setupHeroSlider() {
    var dots = $(".js-hero-slider").data("show-dots") || 0;

    Slider(
        ".js-hero-slider",
        {
            arrows: false,
            swipe: false,
            autoplay: false,
            dots: dots > 1,
        },
        {
            slider: "c-hero-slider",
            viewport: "c-hero-slider__viewport",
            track: "c-hero-slider__track",
            slide: "c-hero-slider__slide",
            slideClone: "c-hero-slider__slide-clone",
            dotList: "c-hero-slider__dots",
            dot: "o-slider__dot",
        }
    );
}

function setupClientSlider() {
    Slider(
        ".js-client-slider",
        {
            arrows: false,
            dots: false,
            autoplaySpeed: 2500,
            slidesToShow: 4,
            slidesToScroll: 1,
            swipe: false,
            autoplay: true,
            buildViewport: false,
            buildTrack: false,
            mobileFirst: false,
            responsive: [
                {
                    breakpoint: 768,
                    options: {
                        slidesToShow: 2,
                    },
                },
            ],
        },
        {
            slider: "c-client-slider",
            viewport: "c-client-slider__viewport",
            track: "c-client-slider__track",
            slide: "c-client-slider__slide",
            slideClone: "c-client-slider__slide-clone",
        },
        {
            prev: '<button class="o-slider__arrow-primary o-slider__arrow-primary--prev"><svg><use xlink:href="images/svgicons.svg#arrow-left"></use></svg></button>',
            next: '<button class="o-slider__arrow-primary o-slider__arrow-primary--next"><svg><use xlink:href="images/svgicons.svg#arrow-right"></use></svg></button>',
        }
    );
}

function setupCaseStudiesSlider() {
    Slider(
        ".js-case-studies-slider",
        {
            arrows: false,
            swipe: false,
            autoplay: false,
            fade: true,
        },
        {
            slider: "c-case-studies-slider",
            viewport: "c-case-studies-slider__viewport",
            track: "c-case-studies-slider__track",
            slide: "c-case-studies-slider__slide",
            slideClone: "c-case-studies-slider__slide-clone",
            dotList: "c-case-studies-slider__dots",
            dot: "o-slider__dot",
        }
    );
}

function setupHeaderSlider() {
    Slider(
        ".js-header-slider",
        {
            arrows: false,
            swipe: true,
            dots: true,
            autoplay: true,
            duration: 750,
        },
        {
            slider: "c-header-slider",
            viewport: "c-header-slider__viewport",
            track: "c-header-slider__track",
            slide: "c-header-slider__slide",
            slideClone: "c-header-slider__slide-clone",
            dotList: "c-header-slider__dots",
            dot: "c-header-slider__dot",
        }
    );
}

function setupVideoOverlay() {
    const jsVideoElements = $(".js-video-overlay");

    if (!jsVideoElements.length) {
        return;
    }

    var tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    const jsVideos = {};

    for (var i = 0; i < jsVideoElements.length; i++) {
        const vidElements = jsVideoElements.get(i);
        const iframe = $(vidElements).find("iframe");
        const parent = iframe.parent().get(0);
        let videoID = iframe.attr("src");
        videoID = videoID.split("?")[0];
        videoID = videoID.split("/");
        videoID = videoID.pop();

        vidElements.dataset.videoid = videoID;

        jsVideos[videoID] = {
            el: vidElements,
            parent,
            videoID,
            player: null,
        };
    }

    function onYouTubeIframeAPIReady() {
        const keys = Object.keys(jsVideos);
        for (let i = 0; i < keys.length; i++) {
            new YT.Player(jsVideos[keys[i]].parent, {
                videoId: jsVideos[keys[i]].videoID,
                events: {
                    onReady: (evt) => {
                        jsVideos[keys[i]].player = evt.target;
                    },
                },
            });
        }
    }
    window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

    jsVideoElements.on("click", function () {
        const target = $(this);
        const videoid = target.data("videoid");

        if (target.hasClass("active")) {
            return;
        }

        target.addClass("active");
        if (jsVideos[videoid].player) {
            jsVideos[videoid].player.playVideo();
        }
    });
}

function setupForms() {
    $("body").on("submit", ".js-form", submitForm);
    $("body").on("change", ".js-filters select", submitFilterForm);
}

function submitForm(event) {
    event.preventDefault();

    var form = $(this),
        url = $(form).attr("action"),
        method = $(form).attr("method"),
        data = $(form).serialize(),
        wrapper = $(form).closest(".js-form-wrapper"),
        tyText = $(wrapper).find(".js-thank-you"),
        btn = $(form).find(".o-btn"),
        btnText = $(btn).text();

    $(btn).prop("disabled", true).text("Please wait...");

    form.find(".js-errors").remove();

    $.ajax({
        url: url,
        method: method,
        data: data,
    })
        .done(function (result) {
            if (result.message) {
                if (result.success) {
                    $(form).slideUp();
                    // Trigger GTAG event
                    window.dataLayer.push({
                        event: "conversion",
                        send_to: "AW-11002450704/10N7CJWrv74YEJCmsP4o"
                    });
                }
                $(tyText).html(result.message).slideDown();

            }

            $(btn).prop("disabled", false).text(btnText);
        })
        .fail(function (xhr, status, error) {
            $.each(xhr.responseJSON, function (k, v) {
                var input = form.find("[name=" + k + "]");
                if (input.length) {
                    var errors = $(
                        '<ul class="js-errors o-form__errors"/></ul>'
                    );

                    $.each(v, function (i, err) {
                        errors.append("<li>" + err + "</li>");
                    });

                    input.closest(".o-form__group").append(errors);
                }
            });

            $(btn).prop("disabled", false).text(btnText);
        });
}

function submitFilterForm(e) {
    e.preventDefault();

    var select = $(this),
        form = select.closest("form");

    form.submit();
}

function animateBacklink() {
    if ($(".js-ese-backlink").length) {
        $(".js-ese-backlink").addClass("in");
    }
}

function setupLinksToPdfs() {
    $('a[href$=".pdf"]').each(function () {
        $(this).attr("target", "_blank");
    });
}

function setupAccordions() {
    $(".o-accordion").accordion({
        collapsible: true,
        active: false,
        heightStyle: "content",
    });
}

function setupSearchbox() {
    $(".js-search-region").on("click", function (event) {
        event.preventDefault();

        var btn = this,
            form = $(btn).closest("form"),
            url = $(form).find("select[name=url]");

        if (url.val() == "") return false;

        return (window.location.href = url.val());
    });
}

function setupSkillsParallax() {
    const slider = $(".c-header-slider__container"),
        middleground = $(".c-skills-parallax__middleground"),
        background = $(".c-skills-parallax__background"),
        backgroundPlane = $(".c-skills-parallax__background-plane"),
        middlegroundBoat = $(".c-skills-parallax__middleground-boat"),
        foregroundPlane = $(".c-skills-parallax__foreground-plane");

    const items = [
        middleground,
        background,
        backgroundPlane,
        middlegroundBoat,
        foregroundPlane,
    ];
    items.forEach((el) => el.css(transform(0, 0, 0)));

    function updateScrollPositions() {
        const scrollTop = $(window).scrollTop();

        if (scrollTop > 350 && !slider.hasClass("fade-out")) {
            slider.addClass("fade-out");
        } else if (scrollTop < 200 && slider.hasClass("fade-out")) {
            slider.removeClass("fade-out");
        }

        if (scrollTop < 700) {
            middleground.css(transform(0, scrollTop, 0));
            background.css(transform(0, scrollTop * 1.5, 0));
            backgroundPlane.css(transform(scrollTop * 1.5, scrollTop / 2, 0));
            middlegroundBoat.css(transform(-(scrollTop * 1.5), scrollTop, 0));
            foregroundPlane.css(
                transform(-(scrollTop * 1.5), scrollTop / 15, 0)
            );
        }
    }

    $(window).on("scroll", updateScrollPositions);
    updateScrollPositions();
}

function initMaps() {
    if (typeof google === "undefined") {
        return;
    }

    $(".js-map").each(function () {
        var el = $(this),
            lat = +el.data("lat"),
            lng = +el.data("lng");

        if (lat && lng) {
            setupMap(el.get(0), lat, lng, false);
        }
    });
}

function setupMap(container, lat, long, interactive) {
    var map = new google.maps.Map(container, {
        center: { lat: lat, lng: long },
        zoom: 15,
        scrollwheel: interactive || false,
        draggable: interactive || false,
        disableDefaultUI: true,
        styles: [
            {
                featureType: "water",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#e9e9e9",
                    },
                    {
                        lightness: 17,
                    },
                ],
            },
            {
                featureType: "landscape",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#f5f5f5",
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                    {
                        lightness: 17,
                    },
                ],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                    {
                        lightness: 29,
                    },
                    {
                        weight: 0.2,
                    },
                ],
            },
            {
                featureType: "road.arterial",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                    {
                        lightness: 18,
                    },
                ],
            },
            {
                featureType: "road.local",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#ffffff",
                    },
                    {
                        lightness: 16,
                    },
                ],
            },
            {
                featureType: "poi",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#f5f5f5",
                    },
                    {
                        lightness: 21,
                    },
                ],
            },
            {
                featureType: "poi.park",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#dedede",
                    },
                    {
                        lightness: 21,
                    },
                ],
            },
            {
                elementType: "labels.text.stroke",
                stylers: [
                    {
                        visibility: "on",
                    },
                    {
                        color: "#ffffff",
                    },
                    {
                        lightness: 16,
                    },
                ],
            },
            {
                elementType: "labels.text.fill",
                stylers: [
                    {
                        saturation: 36,
                    },
                    {
                        color: "#333333",
                    },
                    {
                        lightness: 40,
                    },
                ],
            },
            {
                elementType: "labels.icon",
                stylers: [
                    {
                        visibility: "off",
                    },
                ],
            },
            {
                featureType: "transit",
                elementType: "geometry",
                stylers: [
                    {
                        color: "#f2f2f2",
                    },
                    {
                        lightness: 19,
                    },
                ],
            },
            {
                featureType: "administrative",
                elementType: "geometry.fill",
                stylers: [
                    {
                        color: "#fefefe",
                    },
                    {
                        lightness: 20,
                    },
                ],
            },
            {
                featureType: "administrative",
                elementType: "geometry.stroke",
                stylers: [
                    {
                        color: "#fefefe",
                    },
                    {
                        lightness: 17,
                    },
                    {
                        weight: 1.2,
                    },
                ],
            },
        ],
    });

    var icon = {
        url: "/images/map-marker.png",
        scaledSize: new google.maps.Size(33, 45),
    };

    var marker = new google.maps.Marker({
        position: { lat: lat, lng: long },
        map: map,
        url:
            "https://maps.google.com?saddr=Current+Location&daddr=" +
            lat +
            "," +
            long,
        icon: icon,
    });

    google.maps.event.addListener(marker, "click", function () {
        window.open(marker.url);
    });
}



// WEBPACK FOOTER //
// ./resources/assets/js/src/index.js